module.exports = __webpack_public_path__ + "img/workInfo.30791474.svg";